import PixiStage from './PixiStage'
import MatterEngine from './MatterEngine'

let matter: MatterEngine = null
let pixi: PixiStage = null
const init = () => {
  matter = new MatterEngine('.matter')
  pixi = new PixiStage('.pixi')

  let isFirst = true
  // matter.addRope((points) => pixi.updateRopePoints(points as PIXI.Point[]))
  const mCup = matter.addCup((points, outer) => {
    const outerPoints = {
      lt: outer.lt as PIXI.Point,
      rt: outer.rt as PIXI.Point,
      lb: outer.lb as PIXI.Point,
      rb: outer.rb as PIXI.Point
    }
    pixi.updateCupPoints(points as PIXI.Point[], outerPoints)
  })
  const mStraw = matter.addStraw((x, y, w, h, r) => pixi.updateStraw(x, y, w, h, r))
  // matter.addRope(mCup.edgeLeft, mCup.edgeRight)
  matter.addTapi(points => {
    const waterTop = mCup.waterTop
    const tapiCountUndeTea = points.filter(p => p.y > waterTop).length
    const MAXTAPI = 30
    const BASELINE = 0.4
    const MAXLINE = 0.85
    mCup.waterLevel = BASELINE + (tapiCountUndeTea / MAXTAPI) * (MAXLINE - BASELINE)
    pixi.updateTapiPoints(points as PIXI.Point[])
  })
  window.setTimeout(() => { mCup.capCap() }, 15000)
}

init()
